import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styled from 'styled-components';

gsap.registerPlugin(ScrollTrigger);

const TextContainer = styled.div`
  overflow: hidden;
  font-size: ${(props) => props.theme.typography.h5};
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const Word = styled.span`
  display: inline-block;
  margin-right: 0.3em;
  opacity: 0;
  filter: blur(8px);
  transform: rotateX(90deg);
  transform-origin: bottom;
`;

const ScrollRevealText = ({ children, className }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Split text into words
    const text = children;
    const words = text.split(' ');

    // Clear container and create word spans
    container.innerHTML = '';
    const wordElements = words.map((word, index) => {
      const span = document.createElement('span');
      span.textContent = word;
      span.style.display = 'inline-block';
      span.style.marginRight = '0.3em';
      span.style.opacity = '0';
      span.style.filter = 'blur(8px)';
      span.style.transform = 'rotateX(90deg)';
      span.style.transformOrigin = 'bottom';
      container.appendChild(span);
      return span;
    });

    // Animate words on scroll
    gsap.to(wordElements, {
      opacity: 1,
      filter: 'blur(0px)',
      rotateX: 0,
      duration: 0.8,
      stagger: 0.1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: container,
        start: 'top 80%',
        end: 'bottom 60%',
        scrub: 1,
        toggleActions: 'play none none reverse'
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.trigger === container) {
          trigger.kill();
        }
      });
    };
  }, [children]);

  return <TextContainer ref={containerRef} className={className} />;
};

export default ScrollRevealText;